import React from 'react'
import { func, bool, string } from 'prop-types'
import { translate } from 'react-i18next'

const NavigationButtonsComponent = ({ t, disabled, previous, next, label }) => (
  <div style={{display: 'flex'}}>
    { previous
        ? <button className='btn--lined'
          onClick={() => previous()}
          style={{ marginRight: 16 }}>
          {t('common:visits:step_go_to_previous')}
        </button> : ''
    }
    <button
      className={disabled ? 'btn--default btn--disabled btn--no-select' : 'btn--green'}
      disabled={disabled}
      onClick={() => (!disabled ? next() : '')}>
      { label || t('common:buttons:validate') }
    </button>
  </div>
)

NavigationButtonsComponent.propTypes = {
  t: func,
  next: func,
  previous: func,
  disabled: bool,
  label: string
}

export const NavigationButtons = translate()(NavigationButtonsComponent)



// WEBPACK FOOTER //
// ./src/components/ui/buttons/NavigationButtons.js